import { createAction } from '@reduxjs/toolkit'
import { ContractorFilters } from 'shared/types'

export const setFilters = createAction<ContractorFilters>(
  'contractors/setFilters'
)
export const patchFilters = createAction<Partial<ContractorFilters>>(
  'contractors/patchFilters'
)
export const clearFilters = createAction('contractors/clearFilters')
